import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
} from "@mui/material";
import Box from "@mui/material/Box";
const Order = () => {
  const [open, setOpen] = useState(false);
  const [orders, setOrders] = useState({ flower: "", quantity: 1 });

  // Sample flower data
  const order = [
    { id: 1, name: "Rose", price: 5 },
    { id: 2, name: "Tulip", price: 3 },
    { id: 3, name: "Orchid", price: 8 },
  ];

  // Handle modal open/close
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Handle order changes
  const handleOrderChange = (flower) => {
    setOrders({ ...orders, flower });
  };

  // Handle order submission
  const handleOrderSubmit = () => {
    console.log("Order submitted:", orders);
    handleClose();
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle>Таны захиалга</DialogTitle>
        <DialogContent>
          <TableContainer component={Paper}>
            <Table aria-label="flower table">
              <TableHead>
                <TableRow>
                  <TableCell>Flower Name</TableCell>
                  <TableCell align="right">үнэ (₮)</TableCell>
                  <TableCell align="right">Захиалга</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {order.map((order) => (
                  <TableRow key={order.id}>
                    <TableCell component="th" scope="row">
                      {order.name}
                    </TableCell>
                    <TableCell align="right">{orders.price}</TableCell>
                    <TableCell align="right">
                      <Button
                        variant="outlined"
                        onClick={() => handleOrderChange(orders.name)}>
                        нэмэх
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Input field for quantity */}
          <TextField
            margin="dense"
            label="Quantity"
            type="number"
            fullWidth
            variant="outlined"
            value={orders.quantity}
            onChange={(e) => setOrders({ ...orders, quantity: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              padding: "15px", // Ensures full width to allow spacing
            }}>
            <Button
              variant="contained"
              onClick={handleOrderSubmit}
              color="primary">
              Хадгалах
            </Button>
            <Button variant="contained" color="error" onClick={handleClose}>
              хаах
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Order;
